import { handleResponse } from './apiUtil';
import http from './http-common';

export const getProducts = () => http.get('/admin/stock/products').then(handleResponse);
export const getMonthlyReport = (startDate, endDate) => 
    http.get(`admin/stock/fetch_report?start_date=${startDate}&end_date=${endDate}`)
        .then(handleResponse);
export const getProductsByCustomer = (id) => http.get(`admin/customer/${id}/products`).then(handleResponse);
export const getSuppliersAndProducts = () => http.get('admin/supplier/products').then(handleResponse);
export const checkProductInStock = (id, quantity) => http.get(`admin/check/stock/product/${id}?quantity=${quantity}`).then(handleResponse);
export const checkStock = () => http.get('admin/check/stock').then(handleResponse);
export const authenticateUser = (data) => http.post('admin/user/authorize', data).then(handleResponse);
export const createUser = (data) => http.post('admin/user/create', data).then(handleResponse);
